export default __webpack_public_path__ + "static/media/timeline_2.134ff3ac.svg";